<template>
    <div>
        <el-form :model="info" ref="ruleForm" label-width="100px">
            <el-form-item label="名称" prop="name">
                <!-- <el-input v-model="info.name" disabled style="width:50%"></el-input> -->
                {{ info.name }}
            </el-form-item>
            <el-form-item label="扫码分享">
                <div id="qrcode"></div>
            </el-form-item>
            <el-form-item label="地址" prop="url">
                <!-- <el-input v-model="info.url" disabled style="width:50%"></el-input> -->
                {{ info.url }}
                <!-- &nbsp;&nbsp;<el-button type="primary" @click="copy()">复制链接</el-button> -->
            </el-form-item>

            <el-form-item label="分享标题" prop="share_title">
                <label slot="label"><span style="color:red">*</span>分享标题</label>
                <el-input v-model="info.share_title" placeholder="请输入分享标题" style="width:33%"></el-input>
            </el-form-item>
            <el-form-item label="分享简介" prop="share_desc">
                <label slot="label"><span style="color:red">*</span>分享简介</label>
                <el-input v-model="info.share_desc" placeholder="请输入分享简介" style="width:33%"></el-input>
            </el-form-item>

            <el-form-item label="图片集">
                <el-upload ref="uploadRef" :show-file-list="true" list-type="picture-card" :file-list="fileList"
                    :action="ossAction" :http-request="uploadOSSRequest" :before-upload="beforeImageUpload"
                    :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-change="handleChange">
                    <i class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{ file }" class="invite-upload-file">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt=""
                            @click.stop="handlePictureCardPreview(file)" />
                        <div class="invite-upload-overlay">
                            <div class="invite-image-actions-row">
                                <el-button class="invite-action-button" type="text" icon="el-icon-refresh"
                                    @click.stop="triggerReplace(file)" title="重传"></el-button>
                            </div>
                            <div class="invite-image-actions-row">
                                <el-button class="invite-action-button" type="text" icon="el-icon-zoom-in"
                                    @click.stop="handlePictureCardPreview(file)" title="预览"></el-button>
                                <el-button class="invite-action-button" type="text" icon="el-icon-delete"
                                    @click.stop="removeImage(file)" title="删除"></el-button>
                            </div>
                            <div class="invite-image-actions-row">
                                <el-button class="invite-action-button" type="text" icon="el-icon-arrow-up"
                                    @click.stop="moveUp(file)" :disabled="isFirst(file)" title="上移"></el-button>
                                <el-button class="invite-action-button" type="text" icon="el-icon-arrow-down"
                                    @click.stop="moveDown(file)" :disabled="isLast(file)" title="下移"></el-button>
                            </div>
                        </div>
                    </div>
                </el-upload>
                <input ref="replaceInput" type="file" accept="image/*" style="display:none"
                    @change="handleReplaceChange" />
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="setInviteInfo()" :loading="updateLoading">确 定</el-button>
            </el-form-item>
        </el-form>

        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>

<script>
import {
    beforeImageUpload,
    uploadOSSRequest,
    getAliyunOssToken,
    copyData,
    qrCode
} from "@/api/common";
import {
    getInviteInfo,
    setInviteInfo
} from "@/api/activity";

export default {
    data: function () {
        return {
            fileList: [],
            dialogImageUrl: '',
            dialogVisible: false,
            updateLoading: false,
            ossAction: "",
            replaceIndex: null,
            info: {
                id: 0,
                name: "",
                share_title: "",
                share_desc: "",
                url: "",
                imgs: [],
            },
        };
    },
    created: function () {
        this.info.id = this.$route.query.id;
        this.getInviteInfo();
    },
    methods: {
        // 上传成功钩子：此时 file 是 Upload 内部文件对象（包含 uid、url 等）
        handleUploadSuccess (response, file, fileList) {
            // response 就是我们在 onSuccess 中传入的对象 { url: realUrl }
            // 直接更新 file 对象的 url 属性（使用 $set 确保响应式）
            this.$set(file, 'url', response.url);
            // 可选：更新状态
            this.$set(file, 'status', 'success');

            // 同步 this.fileList 为最新的 fileList（确保列表包含更新后的 file）
            this.fileList = fileList;
        },
        // 文件状态变化时触发（添加、上传成功、上传失败、移除）
        handleChange (file, fileList) {
            // 直接将最新的 fileList 赋给数据属性
            this.fileList = fileList;
        },
        handleRemove (file, fileList) {
            this.fileList = fileList;
        },
        handlePictureCardPreview (file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        moveUp (file) {
            const index = this.fileList.findIndex(item => item.uid === file.uid || item.url === file.url);
            if (index <= 0) return;
            this.swapImages(index, index - 1);
        },
        moveDown (file) {
            const index = this.fileList.findIndex(item => item.uid === file.uid || item.url === file.url);
            if (index === -1 || index >= this.fileList.length - 1) return;
            this.swapImages(index, index + 1);
        },
        swapImages (from, to) {
            const list = this.fileList.slice();
            [list[from], list[to]] = [list[to], list[from]];
            this.fileList = list;
        },
        removeImage (file) {
            const index = this.fileList.findIndex(item => item.uid === file.uid || item.url === file.url);
            if (index !== -1) {
                this.fileList.splice(index, 1);
            }
        },
        triggerReplace (file) {
            this.replaceIndex = this.fileList.findIndex(item => item.uid === file.uid || item.url === file.url);
            if (this.replaceIndex === -1) return;
            this.$refs.replaceInput.click();
        },
        handleReplaceChange (event) {
            const uploadedFiles = event.target.files;
            if (!uploadedFiles || !uploadedFiles.length) {
                this.replaceIndex = null;
                return;
            }
            const file = uploadedFiles[0];
            const index = this.replaceIndex;
            if (index === null || index === -1) {
                this.replaceIndex = null;
                return;
            }

            getAliyunOssToken({ dir: "" }).then((res) => {
                uploadOSSRequest(file, res.data).then((fileUrl) => {
                    const target = this.fileList[index];
                    if (target) {
                        this.$set(this.fileList, index, {
                            ...target,
                            url: fileUrl,
                            status: 'success'
                        });
                    }
                    this.replaceIndex = null;
                    this.$refs.replaceInput.value = null;
                });
            }).catch(() => {
                this.replaceIndex = null;
                this.$refs.replaceInput.value = null;
            });
        },
        isFirst (file) {
            return this.fileList.findIndex(item => item.uid === file.uid || item.url === file.url) === 0;
        },
        isLast (file) {
            const index = this.fileList.findIndex(item => item.uid === file.uid || item.url === file.url);
            return index === this.fileList.length - 1;
        },
        beforeImageUpload (file) {
            beforeImageUpload(file);
        },
        uploadOSSRequest (file) {
            getAliyunOssToken({ dir: "" }).then((res) => {
                uploadOSSRequest(file.file, res.data).then((fileUrl) => {
                    // 更新 fileList 中对应文件的 url（响应式）
                    const target = this.fileList.find(f => f.uid === file.file.uid);
                    if (target) {
                        this.$set(target, 'url', fileUrl);
                        this.$set(target, 'status', 'success');
                    }
                });
            });
        },
        copy () {
            copyData(this.info.url)
            this.$message({
                message: '复制成功',
                type: 'success'
            })
        },
        getInviteInfo () {
            this.updateLoading = true;
            getInviteInfo({
                id: this.info.id,
            }).then((response) => {
                this.info = {
                    id: response.data.id,
                    name: response.data.name,
                    share_title: response.data.share_title,
                    share_desc: response.data.share_desc,
                    url: response.data.url,
                    imgs: response.data.imgs,
                };
                this.$nextTick(function () {
                    document.getElementById("qrcode").innerHTML = "";
                    qrCode(response.data.url, 80, 80);
                });
                // 转换为 Upload 组件所需的格式
                this.fileList = this.info.imgs.map((img, index) => ({
                    // name: img.name,                 // 文件名（可选）
                    url: img,                   // 图片地址（必须）
                    uid: `existing-${index}`,   // 唯一标识
                    status: 'success'                // 状态标记为成功（可选）
                }));
                this.updateLoading = false;
            });
        },
        setInviteInfo () {
            if (this.info.share_title == '' || this.info.share_title == null) {
                this.$message.error('分享标题不能为空')
                return false
            }
            if (this.info.share_desc == '' || this.info.share_desc == null) {
                this.$message.error('分享简介不能为空')
                return false
            }
            if (this.fileList.length == 0) {
                this.$message.error('请至少上传一张图片')
                return false
            }
            this.info.imgs = this.fileList.map(file => file.url);
            this.updateLoading = true;
            setInviteInfo(this.info)
                .then((response) => {
                    this.updateLoading = false;
                    if (response.status == 2000) {
                        this.$message.success(response.message);
                        //刷新当前页面
                        this.$router.go(0);
                    }
                });
        }
    },
}
</script>

<style>
div#qrcode .img {
    width: 80px;
    height: 80px;
    bottom: 10px;
}

.el-upload--picture-card {
    width: 100px;
    height: 178px;
}

.el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 178px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.invite-upload-file {
    position: relative;
    width: 100%;
    height: 100%;
}

.invite-upload-file .el-upload-list__item-thumbnail {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
}

.invite-upload-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    border-radius: 4px;
    opacity: 0;
    transition: opacity 0.2s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 8px 6px;
    gap: 8px;
}

.invite-upload-file:hover .invite-upload-overlay {
    opacity: 1;
}

.invite-image-actions-row {
    display: flex;
    gap: 6px;
    justify-content: center;
}

.invite-image-actions-row:not(:last-child) {
    margin-bottom: 6px;
}

.invite-action-button {
    color: #fff;
    background: transparent;
    border: none;
    padding: 4px;
    min-width: 32px;
    min-height: 32px;
}

.invite-action-button:hover {
    background: rgba(255, 255, 255, 0.12);
}

.invite-action-button .el-icon,
.el-button--text .el-icon-zoom-in,
.el-button--text .el-icon-delete,
.el-button--text .el-icon-arrow-up,
.el-button--text .el-icon-arrow-down {
    font-size: 18px;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 90px;
    height: 160px;
    line-height: 160px;
    text-align: center;
}

.avatar {
    width: 90px;
    height: 160px;
    display: block;
}
</style>